// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "285") return "static/css/285.0995f28b.css";
if (chunkId === "599") return "static/css/599.dd34c138.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}